import React from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="social-links">
        <a href="https://www.facebook.com/firehousespirits?utm_source=website&utm_medium=website&utm_campaign=website"><FaFacebookF /></a>
        <a href="https://www.instagram.com/firehousespirits/?utm_source=website&utm_medium=website&utm_campaign=website"><FaInstagram /></a>
      </div>
      <p>Please Drink Responsibly. ©2025 Fire House Spirits</p>
      <p>
        <a href="https://www.drinkaware.co.uk/" target="_blank" rel="noopener noreferrer" className="drinkaware-link">drinkaware.co.uk</a>
      </p>
      <div className="company-info">
        <p>FIRE HOUSE SPIRITS LTD</p>
        <p>Company number 16781462 | Phone: <a href="tel:01484706191" className="drinkaware-link">01484 706191</a></p>
        <p>Registered office address: Suite 21, Storth House, 156 Cowlersley Lane, Huddersfield, England, HD4 5UX</p>
      </div>
      <div className="design-credit">
        <p>Website Design & Developed by <a href="https://beancreativemarketing.co.uk/" target="_blank" rel="noopener noreferrer dofollow">Bean Creative Marketing</a></p>
      </div>
    </footer>
  );
};

export default Footer;
